document.addEventListener("DOMContentLoaded", function () {

  window.SplideSliderFunction = function () {
    document.querySelectorAll('.splide').forEach((element) => {
      const perPage = parseInt(element.dataset.perPage) || 1;
      const perMove = parseInt(element.dataset.perMove) || 1;
      const gap = element.dataset.gap || '0px';
      const drag = element.dataset.drag === 'true';
      const arrows = element.dataset.arrows === 'true';
      const autoplay = element.dataset.autoplay === 'true';
      const autoplayintervel = parseInt(element.dataset.autoplayintervel);
      const type = element.dataset.type || 'slide';
      const paginatione = element.dataset.pagination === 'true';
      const speed = element.dataset.speed || '600';
      const easing = element.dataset.easing || 'linear';
      const direction = element.dataset.direction || 'ltr';

      const pauseOnHover = element.dataset.pauseOnHover === 'false';
      const pauseOnFocus = element.dataset.pauseOnFocus === 'false';

      const autoHeight = element.dataset.autoHeight === 'false';

      const paddingLeft = element.dataset.paddingLeft
        ? element.dataset.paddingLeft + 'px'
        : 0;

      const paddingRight = element.dataset.paddingRight
        ? element.dataset.paddingRight + 'px'
        : 0;

      let breakpoints = {};
      if (element.dataset.breakpoints) {
        try {
          breakpoints = JSON.parse(element.dataset.breakpoints);
        } catch (e) {
          console.warn('Invalid breakpoints JSON', element.dataset.breakpoints);
        }
      }

      const splide = new Splide(element, {
        type: type,
        perPage: perPage,
        arrows: arrows,
        pagination: paginatione,
        perMove: perMove,
        drag: drag,
        autoplay: autoplay,
        gap: gap,
        interval: autoplayintervel || 3000,
        speed: speed,
        easing: easing,
        direction: direction,
        autoHeight: false,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: pauseOnHover,
        padding: {
          left: paddingLeft,
          right: paddingRight,
        },
        breakpoints: breakpoints,
      });

      /* ✅ Custom arrows */
      const prevBtn = element.querySelector('.splide-custom-prev');
      const nextBtn = element.querySelector('.splide-custom-next');

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          splide.go('<');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          splide.go('>');
        });
      }

      /* ✅ Enable / Disable logic */
      function updateArrows() {
        const endIndex = splide.Components.Controller.getEnd();

        if (prevBtn) {
          if (splide.index === 0) {
            prevBtn.classList.add('is-disabled');
            prevBtn.classList.remove('is-enabled');
            prevBtn.setAttribute('aria-disabled', 'true');
          } else {
            prevBtn.classList.remove('is-disabled');
            prevBtn.classList.add('is-enabled');
            prevBtn.setAttribute('aria-disabled', 'false');
          }
        }

        if (nextBtn) {
          if (splide.index >= endIndex) {
            nextBtn.classList.add('is-disabled');
            nextBtn.classList.remove('is-enabled');
            nextBtn.setAttribute('aria-disabled', 'true');
          } else {
            nextBtn.classList.remove('is-disabled');
            nextBtn.classList.add('is-enabled');
            nextBtn.setAttribute('aria-disabled', 'false');
          }
        }
      }

      splide.on('mounted move', updateArrows);

      /* Progress bar */
      const bar = element.querySelector('.my-carousel-progress-bar');
      if (bar) {
        splide.on('mounted move', function () {
          const totalPages = splide.Components.Controller.getEnd() + 1;
          const currentPage = splide.index + 1;
          bar.style.width = (currentPage / totalPages) * 100 + '%';
        });
      }

      splide.mount();
    });
  };

  SplideSliderFunction();

});



// Image, Video MP4, youtube
// document.addEventListener('click', function (e) {

//   const playBtn = e.target.closest('.video-play-btn');
//   if (!playBtn) return;

//   const wrapper = playBtn.closest('.video-wrapper');
//   if (!wrapper) return;

//   const cover = wrapper.querySelector('.video-cover');
//   const embed = wrapper.querySelector('.video-embed');
//   const videoUrl = wrapper.dataset.videoUrl;

//   if (cover) cover.style.display = 'none';

//   // ✅ Only toggle if embed exists
//   if (embed) {
//     embed.classList.toggle('isplay');

//     const shopifyVideo = embed.querySelector('video');

//     if (shopifyVideo) {
//       shopifyVideo.play();
//     } else if (videoUrl && videoUrl.endsWith('.mp4')) {
//       embed.innerHTML = `
//         <video autoplay muted controls playsinline>
//           <source src="${videoUrl}" type="video/mp4">
//         </video>
//       `;
//     } else if (videoUrl && videoUrl.includes('youtube')) {
//         const videoId = videoUrl.split('v=')[1]?.split('&')[0];
//         if (videoId) {
//           embed.innerHTML = `
//             <iframe
//               src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1"
//               frameborder="0"
//               allow="autoplay; encrypted-media"
//               allowfullscreen>
//             </iframe>
//           `;
//         }
//     }
//   }

// });


if (!window.customVideoHandlerInitialized) {

  window.customVideoHandlerInitialized = true;

  document.addEventListener('click', function (e) {

    const playBtn = e.target.closest('.video-play-btn');
    if (!playBtn) return;

    const wrapper = playBtn.closest('.video-wrapper');
    if (!wrapper) return;

    const cover = wrapper.querySelector('.video-cover');
    const embed = wrapper.querySelector('.video-embed');
    const videoUrl = wrapper.dataset.videoUrl;

    if (!embed) return;

    const shopifyVideo = embed.querySelector('video');

    // ✅ If Shopify hosted video exists → toggle play/pause
    if (shopifyVideo) {

      embed.classList.toggle('isplay');

      if (shopifyVideo.paused) {
        shopifyVideo.play();
      } else {
        shopifyVideo.pause();
      }

      if (cover) cover.style.display = 'none';
      return;
    }

    // For injected videos → only add once
    embed.classList.add('isplay');
    
    if (cover) cover.style.display = 'none';

    // MP4 video
    if (videoUrl && videoUrl.endsWith('.mp4')) {
      embed.innerHTML = `
        <video autoplay muted controls playsinline>
          <source src="${videoUrl}" type="video/mp4">
        </video>
      `;
      return;
    }

    // YouTube video
    if (videoUrl && videoUrl.includes('youtube')) {
      let videoId = '';

      try {
        const urlObj = new URL(videoUrl);
        videoId = urlObj.searchParams.get('v');
      } catch (err) {}

      if (!videoId) return;

      embed.innerHTML = `
        <iframe
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen>
        </iframe>
      `;
    }

  });

}


// Taem



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pop-btn').forEach(function (tab) {
    tab.addEventListener('click', function () {
      const tab_id = this.getAttribute('data-tab');

      // remove the default classes
      document.querySelectorAll('.pop-btn').forEach(el => el.classList.remove('current'));
      document.querySelectorAll('.pop-panel').forEach(el => el.classList.remove('current'));

      // add new classes on click
      this.classList.add('current');
      const target = document.getElementById(tab_id);
      if (target) target.classList.add('current');
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const closeTargets = document.querySelectorAll('.popup-close, .popup--overlay');

  closeTargets.forEach(function (el) {
    el.addEventListener('click', function () {
      document.querySelectorAll('.current').forEach(item => item.classList.remove('current'));
    });
  });
});


// LOAD MORE
   



// Project gallery
document.addEventListener('DOMContentLoaded', function () {
  const divs = document.querySelectorAll('.gallery-img');
  let count = 1;

  for (let i = 0; i < divs.length; i += 9) {
    const group = Array.from(divs).slice(i, i + 9);

    // Create gallery-main wrapper
    const galleryMain = document.createElement('div');
    galleryMain.className = `gallery-main gallery-main-${count}`;

    // Wrap the 9 items
    group[0].parentNode.insertBefore(galleryMain, group[0]);
    group.forEach(el => galleryMain.appendChild(el));

    // Left column wrap
    const leftItems = galleryMain.querySelectorAll(
      '.gall-item-1, .gall-item-3, .gall-item-4, .gall-item-6'
    );
    if (leftItems.length) {
      const leftCol = document.createElement('div');
      leftCol.className = 'gall-col-left gall-col';
      leftItems[0].parentNode.insertBefore(leftCol, leftItems[0]);
      leftItems.forEach(el => leftCol.appendChild(el));
    }

    // Right column wrap
    const rightItems = galleryMain.querySelectorAll(
      '.gall-item-2, .gall-item-5, .gall-item-7, .gall-item-8, .gall-item-9'
    );
    if (rightItems.length) {
      const rightCol = document.createElement('div');
      rightCol.className = 'gall-col-right gall-col';
      rightItems[0].parentNode.insertBefore(rightCol, rightItems[0]);
      rightItems.forEach(el => rightCol.appendChild(el));
    }

    count++;
  }
});

// Gallery Load more

   

